// GENERATED by ~/yoke/paid-attribution/b2b/build-port.mjs from core/attribution-core.ts (sha256 381301d9550c9f21). Browser IIFE → window.YkAttrCore.
// DO NOT EDIT: change the core, then re-run the build. The port test runs the core's own test cases against this file.
(function (root) {
"use strict";
// Paid ads attribution core (contract: ~/yoke/paid-attribution/SPEC.md §1, §4). Pure: no DOM, no I/O, so every site
// vendors this one file unchanged and the rules can't drift. Sites supply the URL, referrer, own host, page id and clock.

const ATTR_VERSION = 1;
const COOKIE_NAME = "yk_attr";
const CONSENT_COOKIE = "yk_consent";
const COOKIE_DAYS = 180;
const MAX_VALUE = 200;

const CREATIVE_RE = /^(OEM|B2B|CBB)-\d{5}$/i;

/** URL params copied onto a touch, keyed by the touch field name. */
const PARAMS                         = {
  utm_source: "source", utm_medium: "medium", utm_campaign: "campaign", utm_content: "content", utm_term: "term",
  yoke_product: "product", yoke_brand_type: "brand_type", yoke_concept: "concept", yoke_funnel: "funnel",
  yoke_format: "format", yoke_landing: "landing_hint",
  yk_cid: "yk_cid", yk_asid: "yk_asid", yk_adid: "yk_adid", yk_place: "yk_place",
  gclid: "gclid", fbclid: "fbclid", li_fat_id: "li_fat_id", msclkid: "msclkid",
};
const CLICK_IDS = ["gclid", "fbclid", "li_fat_id", "msclkid"]         ;

const TOUCH_KEYS = [
  "at", "source", "medium", "campaign", "content", "term", "creative_id", "product", "brand_type", "concept", "funnel", "format",
  "landing_hint", "yk_cid", "yk_asid", "yk_adid", "yk_place", "gclid", "fbclid", "li_fat_id", "msclkid", "referrer", "landing_url", "landing_page_id",
]         ;




/** "OEM-00172" (any case) → "OEM-00172"; anything else → "". */
function normaliseCreativeId(v                           )         {
  const s = (v ?? "").trim();
  return CREATIVE_RE.test(s) ? s.toUpperCase() : "";
}

const clip = (s        ) => s.slice(0, MAX_VALUE);

function hostOf(u        )         {
  try { return new URL(u).hostname.toLowerCase().replace(/^www\./, ""); } catch { return ""; }
}

/** Registrable-ish domain: last two labels, or last three for co.uk-style suffixes. Enough for our three sites + referrers. */
function siteOf(host        )         {
  const parts = host.toLowerCase().replace(/^www\./, "").split(".").filter(Boolean);
  if (parts.length <= 2) return parts.join(".");
  const sld = parts[parts.length - 2];
  const n = ["co", "com", "org", "net", "ac", "gov"].includes(sld) && parts[parts.length - 1].length === 2 ? 3 : 2;
  return parts.slice(-n).join(".");
}

const SEARCH                         = { google: "google", bing: "bing", "duckduckgo": "duckduckgo", yahoo: "yahoo", ecosia: "ecosia", baidu: "baidu", yandex: "yandex" };
const SOCIAL                         = {
  "facebook.com": "facebook", "fb.com": "facebook", "m.facebook.com": "facebook", "l.facebook.com": "facebook", "lm.facebook.com": "facebook",
  "instagram.com": "instagram", "l.instagram.com": "instagram", "linkedin.com": "linkedin", "lnkd.in": "linkedin", "t.co": "x", "x.com": "x",
  "twitter.com": "x", "tiktok.com": "tiktok", "youtube.com": "youtube", "reddit.com": "reddit", "pinterest.com": "pinterest", "threads.net": "threads",
};

/** Payment / sign-in hops that send the visitor back to us: never a touch (Stripe return, Google/Apple sign-in, PayPal, Shop Pay). */
const PASS_THROUGH = [
  "checkout.stripe.com", "stripe.com", "accounts.google.com", "appleid.apple.com", "paypal.com", "shop.app", "pay.shopify.com", "checkout.shopify.com",
];
function isPassThrough(refHost        )          {
  const h = refHost.toLowerCase().replace(/^www\./, "");
  return PASS_THROUGH.some((p) => h === p || h.endsWith(`.${p}`));
}

/** Referrer-only touch → source/medium (SPEC §4). */
function classifyReferrer(refHost        )                                     {
  const site = siteOf(refHost);
  const social = SOCIAL[refHost] ?? SOCIAL[site];
  if (social) return { source: social, medium: "social" };
  const brand = site.split(".")[0];
  if (SEARCH[brand]) return { source: SEARCH[brand], medium: "organic" };
  return { source: site || refHost, medium: "referral" };
}






                                                   





/** The touch this arrival represents, or null when it is a direct / internal visit that must not change anything. */
function touchFromVisit(v            )               {
  let u     ;
  try { u = new URL(v.url); } catch { return null; }
  const t        = {};
  for (const [param, key] of Object.entries(PARAMS)) {
    const val = u.searchParams.get(param);
    if (val && val.trim()) t[key            ] = clip(val.trim());
  }
  const refHost = hostOf(v.referrer);
  const ownSite = siteOf(u.hostname);
  const external = !!refHost && siteOf(refHost) !== ownSite && !isPassThrough(refHost);
  const tagged = !!t.source || CLICK_IDS.some((k) => t[k]);
  if (!tagged && !external) return null;

  if (!t.source) {
    if (t.gclid) Object.assign(t, { source: "google", medium: "cpc" });
    else if (t.fbclid) Object.assign(t, { source: "meta", medium: "paid_social" });
    else if (t.li_fat_id) Object.assign(t, { source: "linkedin", medium: "paid_social" });
    else if (t.msclkid) Object.assign(t, { source: "bing", medium: "cpc" });
    else Object.assign(t, classifyReferrer(refHost));
  }
  const cid = normaliseCreativeId(t.content);
  if (cid) t.creative_id = cid;
  if (external) t.referrer = clip(v.referrer);
  u.hash = "";
  t.landing_url = clip(u.toString());
  if (v.landingPageId) t.landing_page_id = clip(v.landingPageId);
  t.at = v.now;
  return t;
}

/** Apply one arrival to the stored state: ft written once, lt replaced by every non-direct arrival. */
function applyVisit(state                              , v            )            {
  const s            = { v: ATTR_VERSION, ...(state?.ft ? { ft: state.ft } : {}), ...(state?.lt ? { lt: state.lt } : {}) };
  const t = touchFromVisit(v);
  if (!t) return s;
  if (!s.ft) s.ft = t;
  s.lt = t;
  return s;
}

/** Server side: keep only known keys, strings, clipped; creative ids re-validated. Never trust anything else from the client. */
function sanitiseTouch(x         )                    {
  if (!x || typeof x !== "object") return undefined;
  const out        = {};
  for (const k of TOUCH_KEYS) {
    const val = (x                           )[k];
    if (typeof val === "string" && val.trim()) out[k] = clip(val.trim().replace(/[\u0000-\u001f]/g, ""));
  }
  if ("creative_id" in out) {
    const c = normaliseCreativeId(out.creative_id);
    if (c) out.creative_id = c; else delete out.creative_id;
  }
  if (out.at && Number.isNaN(Date.parse(out.at))) delete out.at;
  return Object.keys(out).length ? out : undefined;
}

function sanitiseState(x         )            {
  const o = (x && typeof x === "object" ? x : {})                           ;
  const ft = sanitiseTouch(o.ft);
  const lt = sanitiseTouch(o.lt);
  return { v: ATTR_VERSION, ...(ft ? { ft } : {}), ...(lt ? { lt } : {}) };
}

function encodeState(s           )         {
  return encodeURIComponent(JSON.stringify(s));
}

function decodeState(raw                           )                   {
  if (!raw) return null;
  try { return sanitiseState(JSON.parse(decodeURIComponent(raw))); } catch { return null; }
}

/** Meta click cookie value (SPEC §4): fb.1.<ms>.<fbclid>. */
function fbcFromFbclid(fbclid        , nowMs        )         {
  return `fb.1.${nowMs}.${fbclid}`;
}

/** Countries where the banner is shown and storage waits for Accept (UK, EEA, CH). */
const CONSENT_COUNTRIES = new Set([
  "GB", "UK", "CH", "IS", "LI", "NO",
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE",
]);

/** Unknown country = ask (fail safe). */
function needsConsent(country                           )          {
  const c = (country ?? "").trim().toUpperCase();
  return !c || CONSENT_COUNTRIES.has(c);
}

/** Flat fields for CRM rows (Airtable enquiry, Stripe metadata). `prefix` "ft"/"lt". */
function flatTouch(prefix             , t                   )                         {
  if (!t) return {};
  const f                         = {
    [`${prefix}_creative_id`]: t.creative_id ?? "",
    [`${prefix}_source`]: t.source ?? "",
    [`${prefix}_medium`]: t.medium ?? "",
    [`${prefix}_campaign`]: t.campaign ?? "",
    [`${prefix}_at`]: t.at ?? "",
    [`${prefix}_landing_page_id`]: t.landing_page_id ?? "",
  };
  if (prefix === "ft") f.ft_platform_ad_id = t.yk_adid ?? "";
  for (const k of Object.keys(f)) if (!f[k]) delete f[k];
  return f;
}

/** "fbclid=…, gclid=…" from both touches (latest wins per key). */
function clickIds(s           )         {
  const ids                         = {};
  for (const t of [s.ft, s.lt]) for (const k of CLICK_IDS) if (t?.[k]) ids[k] = t[k] ;
  return Object.entries(ids).map(([k, v]) => `${k}=${v}`).join(", ");
}

root.YkAttrCore = { ATTR_VERSION, COOKIE_NAME, CONSENT_COOKIE, COOKIE_DAYS, MAX_VALUE, TOUCH_KEYS, normaliseCreativeId, siteOf, isPassThrough, classifyReferrer, touchFromVisit, applyVisit, sanitiseTouch, sanitiseState, encodeState, decodeState, fbcFromFbclid, CONSENT_COUNTRIES, needsConsent, flatTouch, clickIds };
})(typeof window !== "undefined" ? window : globalThis);
